import createReactComponent from '../createReactComponent';
export default createReactComponent('wave-square', 'IconWaveSquare', [
  ['path', { d: 'M3 12h5v8h4v-16h4v8h5', key: 'svg-0' }],
]);
